import { Component, Prop, Vue } from 'vue-property-decorator';
import { ICard } from '../../../../interfaces/Card';

@Component
export default class Card extends Vue {
	@Prop() card!: ICard;

	@Prop() cardSize!: string;

	get bgImgStyle() {
		return `background-image: url("${this.card.image.url.replace(
			'/@http\b',
			'https'
		)}")`;
	}
}
